
const digest = '8c024adb1f4e36296d259bc20d22d295e97410f23f3fc0429c42c7f454c1b2c9';
const classes = {"wrapper":"_wrapper_9na80_1","item":"_item_9na80_8","itemClickable":"_itemClickable_9na80_21","itemWithIcon":"_itemWithIcon_9na80_27"};
const css = `._wrapper_9na80_1 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
}

._item_9na80_8 {
  display: inline-block;
  background-color: #f0f7ff;
  border: 1px solid #d1e7ff;
  border-radius: 4px;
  padding: 4px 8px;
  margin: 2px 4px 2px 0;
  font-size: 12px;
  font-weight: 500;
  color: #1e40af;
  white-space: nowrap;
}

._itemClickable_9na80_21:hover {
  background-color: #e0f2fe;
  border-color: #b3d9ff;
  cursor: pointer;
}

._itemWithIcon_9na80_27 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  vertical-align: middle;
  padding: 0 4px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  